<template lang="pug">
div(v-if='workspace && version')
  app-header
    .ObjectsMenu
      b.Menu-title ОБЪЕКТЫ:
      .ObjectsMenu-nav
        header-button(
          :isActive='panels.layers',
          title='Слои',
          icon='IconPanelLayers',
          @clicked='panels.layers ? (panels.layers = false) : openLayers()'
        )
        header-button(
          v-if='objectsPeriod && canEditWs && !isPublicWs',
          :isActive='panels.priority',
          title='Настройка потоков',
          icon='IconPanelPriority',
          @clicked='priorityConfigClick'
        )

        header-button(
          v-if='objectsPeriod && canEditWs && !isPublicWs',
          :isActive='panels.zoneGroups',
          title='Редактирование зон',
          icon='IconPanelZoneGroups',
          @clicked='toggleZoneGroup'
        )
        header-button(
          v-if='objectsPeriod',
          :isActive='panels.additional',
          title='Выбор периода',
          icon='IconPanelTimeline',
          @clicked='toggleAdditional'
        )
        //header-button(
          v-if='objectsPeriod',
          :isActive="panels.territories",
          title="Настройка выделенных террииторий",
          icon="IconPanelTerritories",
          @clicked="toggleTerritories")
      waste-header-panel.ObjectsMenu-treatments-select(v-if='objectsPeriod')

      .Objects-switcher(v-if='objectsPeriod && !isZoneMode')
        switcher(
          v-model='show3dMap',
          @mouseover='toggle3dFlowMapHelperText',
          @mouseout='helperText = null'
        ) Потоки в 3D
  .Objects-spinner(v-if='isInitLoading')
    fade-loader.Spinner(
      :loading='isInitLoading',
      color='#27bd8a',
      height='8px',
      width='3px',
      radius='10px'
    )
  .SP(v-else)
    splitpanes.hscreen(
      horizontal='',
      ref='panes',
      @pane-add='changePanes',
      @pane-remove='changePanes',
      @resized='changePanes'
    )
      pane(
        ref='mainPaneWrapper',
        paneId='wrapper',
        :flexible='true',
        :min-size='50',
        :size='mainPaneHeight',
        :dbl-click-splitter='false'
      )
        splitpanes(
          vertical='',
          ref='panes',
          @resized='changePanes',
          @ready='ready = true',
          @pane-add='changePanes',
          @pane-remove='changePanes'
        )
          pane(
            key='layers',
            paneId='layers',
            v-if='!isInitLoading && panels.layers',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.layers',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='closeLayers()',
              titleHtml='Слои'
            )
              template(
                v-if='$isMobile',
                v-slot:actions=''
              )
                button-group.LayerButtonsInBurger(
                  iconCss='IconBurger',
                  :items='layersButtons'
                )
              template(
                v-else,
                v-slot:actions=''
              )
                button.Btn.BtnIcon(
                  v-for='buttonItem in layersButtons',
                  :key='buttonItem.code',
                  @mouseover='buttonItem.mouseover',
                  @mouseout='buttonItem.mouseout',
                  @click='buttonItem.click'
                )
                  i.Icon(:class='buttonItem.iconCss')
                //button.Btn.BtnIcon(@click="openEditLayerPanel")
                  i.Icon.IconPlus

              template(v-slot:content='')
                objects-layers(
                  @openFilters='toggleFiltersPanel',
                  @objectFiltersChanged='handleObjectFiltersChanged',
                  :mainLoaded='mainLoaded',
                  :isSearchPanelOpened='panels.filters',
                  :show3dMap='show3dMap'
                )
          pane(
            key='filters',
            paneId='filters',
            v-if='panels.filters',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.filters',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='closeFilters()',
              titleHtml='Фильтры'
            )
              template(v-slot:content='')
                layers-filters-list
          pane(
            key='priority',
            paneId='priority',
            v-if='panels.priority',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.layers',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='closePriorities()',
              titleHtml='Правила'
            )
              template(v-slot:content='')
                priority-rules

          pane(
            key='edit',
            paneId='edit',
            v-if='panels.edit',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.edit',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='panels.edit = false',
              titleHtml='Редактирование'
            )
              template(v-slot:content='')
                objects-edit
          pane(
            key='zoneGroups',
            paneId='zoneGroups',
            v-if='panels.zoneGroups',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.zoneGroups',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='toggleZoneGroup',
              titleHtml='Настройка зон'
            )
              template(v-slot:content='')
                zone-layers(:mainLoaded='mainLoaded')
          pane(
            key='zoneGroup',
            paneId='zoneGroup',
            v-if='panels.zoneGroup',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.zoneGroup',
            :dbl-click-splitter='false'
          )
            layout-panel(
              :isBlueBg='true',
              @close='closeZoneGroup',
              :titleHtml='zoneGroupToEdit.type === "zone" ? (zoneGroupToEdit.id ? "Редактирование зоны" : "Создание зоны") : zoneGroupToEdit.id ? "Редактирование группы зон" : "Создание группы зон"'
            )
              template(v-slot:content='')
                edit-zone(v-if='zoneGroupToEdit.type === "zone"')
                edit-zone-group(v-if='zoneGroupToEdit.type === "zonegroup"')
          pane(
            key='territories',
            paneId='territories',
            v-if='panels.territories',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.territories',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='toggleTerritories',
              titleHtml='Настройка выделенных территорий'
            )
              template(v-slot:content='')
                territory-list

          pane(
            key='mapBlock',
            paneId='mapBlock',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.map',
            :dbl-click-splitter='false',
            :flexible='true'
          )
            splitpanes(
              horizontal='',
              @ready='ready = true',
              @resized='mapResized'
            )
              pane(
                key='map',
                paneId='map',
                :size='mapHeight',
                v-if='ready',
                :dbl-click-splitter='false',
                :flexible='true'
              )
                layout-panel(
                  :closable='false',
                  :hasHeader='false'
                )
                  template(v-slot:content='')
                    territory-map(
                      :resize='newMapContainerSize',
                      v-if='panels.territories'
                    )
                    objects-map(
                      v-else-if='!show3dMap',
                      ref='objectsMap',
                      :resize='newMapContainerSize',
                      :buttons='{ print: true }',
                      :mainLoaded='mainLoaded'
                    )
                    objects-map-3d(v-else)
              pane(
                key='route',
                paneId='route',
                v-if='objectShowContainerRoute',
                min-size='15',
                :size='routeHeight',
                :dbl-click-splitter='false'
              )
                layout-panel(
                  @close='resetShowContainerRoute',
                  titleHtml='Путь отходов'
                )
                  template(v-slot:content='')
                    container-route
              pane(
                key='additional',
                paneId='additional',
                v-if='panels.additional',
                :min-size='$isMobile ? 25 : 0',
                :size='additionalHeight',
                :dbl-click-splitter='false'
              )
                layout-panel(
                  @close='objectDetailsSelected ? resetObjectDetailsSelected() : toggleAdditional()',
                  :titleHtml='objectDetailsSelected ? `Изменяющиеся атрибуты (${selectedObjectName || objectDetailsSelected.title})` : "Период"'
                )
                  template(v-slot:content='')
                    objects-additional-attributes(
                      @openPeriodPanel='periodPanelSettings = $event',
                      :initialSelectedIntervals='selectedIntervals'
                    )
          pane(
            key='main',
            paneId='main',
            v-if='objectSelected && panels.main',
            :min-size='$isMobile ? 25 : 20',
            :size='currentSizes.main',
            :dbl-click-splitter='false'
          )
            layout-panel(
              @close='resetObjectSelected',
              titleHtml='Основные атрибуты объекта'
            )
              template(v-slot:content='')
                div
                .Objects-spinner(v-if='objectSelected.type !== "clusterRoute" && objectStaticInfo.length === 0')
                  fade-loader.Spinner(
                    :loading='objectStaticInfo.length === 0',
                    color='#27bd8a',
                    height='8px',
                    width='3px',
                    radius='10px'
                  )
                main-attributes-object(
                  :resize='newMapContainerSize',
                  v-if='objectStaticInfo.length === 1'
                )
                main-attributes-group(
                  :resize='newMapContainerSize',
                  v-if='objectStaticInfo.length > 1'
                )
                main-attributes-cluster-route(
                  :resize='newMapContainerSize',
                  v-if='objectSelected.type === "clusterRoute"'
                )
      pane(
        key='rule',
        paneId='rule',
        v-if='panels.editRule',
        min-size='30',
        :size='currentSizes.rule',
        :dbl-click-splitter='false'
      )
        layout-panel(
          v-if='priorityRuleToEdit.type === "zoneGroup"',
          @close='resetRuleToEdit',
          titleHtml='Ограничения потоков по группам зон'
        )
          template(v-slot:content='')
            priority-zones
        layout-panel(
          v-if='priorityRuleToEdit.type === "infrastructure_upload_queue"',
          @close='resetRuleToEdit',
          titleHtml='Очередь загрузки объектов инфраструктуры'
        )
          template(v-slot:content='')
            priority-queue
        layout-panel(
          v-if='priorityRuleToEdit.type === "priority_disposal_wastes_from_processing"',
          @close='resetRuleToEdit',
          titleHtml='Приоритетное захоронение отходов, идущих от объектов обработки'
        )
          template(v-slot:actions='')
            priority-settings
          template(v-slot:content='')
            priority-treatment
        layout-panel(
          v-if='priorityRuleToEdit.type === "flows"',
          @close='resetRuleToEdit',
          titleHtml='Привязки отдельных направлений потоков отходов'
        )
          template(v-slot:actions='')
            priority-flow-actions(v-if='!territoryLoading && !territoryLoadingError')
          template(v-slot:content='')
            priority-flows(
              @territoryLoadingStart='handleTerritoryLoadingStart',
              @territoryLoadingEnd='territoryLoading = false',
              @territoryLoadingError='territoryLoadingError = true'
            )
    period-panel(
      v-click-outside='hidePeriodPanel',
      v-if='periodPanelSettings',
      @close='hidePeriodPanel',
      @intervalsChanged='changeIntervals',
      :settings='periodPanelSettings'
    )
    .ObjectsModal(v-if='showPriorityModal && objectsPeriod')
      priority-modal
    .ObjectsModal(v-if='showInfrastructureModal')
      modal-infrastructure
    .ObjectsModal(v-if='showTechnologyModal')
      modal-technology
    .ObjectsModal(v-if='markerLayersToEdit')
      building(v-if='markerLayersToEdit.type === "building"')
      emitter(v-if='markerLayersToEdit.type === "emitter"')
      container-platform(v-if='markerLayersToEdit.type === "containerplatform"')
</template>

<script>
import ClickOutside from 'vue-click-outside'
import ColorSettings from '@/components/popups/ColorSettings'
import { Splitpanes, Pane } from '@/components/splitpanes'
import common from '@/mixins/common'
import panes from '@/mixins/panes'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'Objects',
  components: {
    'waste-header-panel': () => import('@/components/WasteHeaderPanel'),
    'layers-filters-list': () => import('@/components/objects/LayersFiltersList'),
    'priority-modal': () => import('@/components/objects/priorities/PriorityModal'),
    'modal-infrastructure': () => import('@/components/objects/infrastructure/ModalInfrastructure'),
    'modal-technology': () => import('@/components/objects/infrastructure/ModalTechnology'),
    'priority-flows': () => import('@/components/objects/priorities/PriorityFlows'),
    'priority-treatment': () => import('@/components/objects/priorities/PriorityTreatment'),
    'priority-queue': () => import('@/components/objects/priorities/PriorityQueue'),
    'priority-zones': () => import('@/components/objects/priorities/PriorityZones'),
    'priority-rules': () => import('@/components/objects/priorities/PriorityRules'),
    'priority-settings': () => import('@/components/objects/priorities/PrioritySettings'),
    'priority-flow-actions': () => import('@/components/objects/priorities/PriorityFlowActions'),
    'zone-layers': () => import('@/components/objects/zoneGroup/ZoneLayers'),
    'edit-zone': () => import('@/components/objects/zoneGroup/EditZone'),
    'edit-zone-group': () => import('@/components/objects/zoneGroup/EditZoneGroup'),
    'territory-list': () => import('@/components/objects/territories/TerritoryList'),
    'territory-map': () => import('@/components/objects/territories/TerritoryMap'),
    'header-button': () => import('@/components/HeaderButton'),
    'app-header': () => import('@/components/AppHeader'),
    'period-panel': () => import('@/components/analytics/PeriodPanel'),
    'objects-additional-attributes': () => import('@/components/objects/AdditionalAttributes'),
    'objects-edit': () => import('@/components/objects/Edit'),
    'objects-layers': () => import('@/components/objects/Layers'),
    'objects-map': () => import('@/components/objects/Map'),
    'objects-map-3d': () => import('@/components/objects/Map3d'),
    'container-route': () => import('@/components/objects/ContainerRoute'),
    'main-attributes-object': () => import('@/components/objects/mainAttributes/MainAttributesObject'),
    'main-attributes-group': () => import('@/components/objects/mainAttributes/MainAttributesGroup'),
    'main-attributes-cluster-route': () => import('@/components/objects/mainAttributes/MainAttributesClusterRoute'),
    'layout-panel': () => import('@/components/LayoutPanel'),
    building: () => import('@/components/objects/markerLayers/Building'),
    emitter: () => import('@/components/objects/markerLayers/Emitter'),
    'container-platform': () => import('@/components/objects/markerLayers/ContainerPlatform'),
    'fade-loader': () => import('vue-spinner/src/FadeLoader.vue'),
    Switcher: () => import('@/components/Switcher'),
    'button-group': () => import('@/components/ButtonGroup'),
    Splitpanes,
    Pane
  },
  mixins: [common, panes, helpertext],
  directives: {
    ClickOutside
  },
  data() {
    return {
      territoryLoading: false,
      territoryLoadingError: false,
      checkCacheTimeout: null,
      show3dMap: false,
      container: {
        width: 0,
        height: 0
      },
      mainLoaded: false,
      editList: [
        // temp
        {
          id: '1',
          right: 'Ctrl+Shift+T',
          left: 'Создать точку'
        },
        {
          id: '2',
          right: 'Ctrl+Shift+P',
          left: 'Создать полигон'
        },
        {
          id: '3',
          right: 'Ctrl+L',
          left: 'Создать линию'
        },
        {
          id: '45',
          right: 'Ctrl+M',
          left: 'Редактировать/удалить точку'
        },
        {
          id: '4',
          right: 'Ctrl+O',
          left: 'Редактировать/удалить полигон'
        },
        {
          id: '5',
          right: 'Ctrl+O',
          left: 'Редактировать/удалить линию'
        }
      ],
      analysisList: [
        // temp
        {
          id: '1',
          right: 'Shift+T',
          left: 'Пересечение'
        },
        {
          id: '2',
          right: 'Shift+P',
          left: 'Включение'
        },
        {
          id: '3',
          right: 'Ctrl+L',
          left: 'Исключение'
        },
        {
          id: '45',
          right: 'Ctrl+M',
          left: 'Разность'
        },
        {
          id: '4',
          right: 'Ctrl+O',
          left: 'В радиусе'
        }
      ],
      periodPanelSettings: null,
      selectedIntervals: [],
      defaultPanels: {
        analysis: false,
        filters: false,
        edit: false,
        layers: false,
        priority: false,
        additional: false,
        editLayer: false,
        main: false,
        route: true,
        rule: false,
        editRule: false,
        zoneGroups: false,
        zoneGroup: false,
        territories: false
      },
      panels: {},
      ready: false,
      savedSizes: {},
      currentSizes: {
        analysis: 20,
        editLayer: 20,
        edit: 20,
        layers: this.$isMobile ? 30 : 25,
        filters: this.$isMobile ? 30 : 20,
        priority: this.$isMobile ? 30 : 20,
        map: 80,
        rule: 50,
        main: this.$isMobile ? 30 : 20,
        zoneGroups: this.$isMobile ? 30 : 25,
        zoneGroup: this.$isMobile ? 30 : 20,
        territories: 20
      },
      newMapContainerSize: null,
      newAttrContainerSize: null
    }
  },
  beforeDestroy() {
    this.$store.dispatch('totalObjectsReset')
    clearTimeout(this.checkCacheTimeout)
  },
  computed: {
    layersButtons() {
      let layersButtons = [
        {
          code: 'linkColor',
          iconCss: 'IconColorSettings',
          mouseover: () => (this.helperText = 'Настройка связей покрасок'),
          mouseout: () => (this.helperText = null),
          click: () => this.openLayerLinkColorPopup()
        },
        {
          code: 'collapseAllGroups',
          iconCss: 'IconCollapse',
          mouseover: () => (this.helperText = 'Свернуть все слои'),
          mouseout: () => (this.helperText = null),
          click: () => this.collapseAllLayers()
        },
        {
          code: 'restoreDefaultVisibility',
          iconCss: 'IconRepeat',
          mouseover: () => (this.helperText = 'Восстановить видимость слоев по умолчанию'),
          mouseout: () => (this.helperText = null),
          click: () => this.forceDefaultVisibilityPanels()
        },
        {
          code: 'hideAllLayers',
          iconCss: 'IconHidden',
          mouseover: () => (this.helperText = 'Скрыть все слои'),
          mouseout: () => (this.helperText = null),
          click: () => this.hideAllLayers()
        }
      ]

      //Согласно задаче https://app.clickup.com/t/33yy1t7
      //Владелец пространства может менять стили общего (shared) рабочего пространства, невладелец не может
      if (this.canEditWs && this.$store.getters.permissions.canEditDataVersion && (!this.sharedWs || this.isUserWsOwner)) {
        layersButtons.unshift({
          code: 'layerSettings',
          iconCss: 'IconLayerSettings',
          mouseover: () => (this.helperText = 'Настройки и стили слоев'),
          mouseout: () => (this.helperText = null),
          click: () => this.openLayerSettingsPopup()
        })
      }

      return layersButtons
    },
    isZoneMode() {
      return this.$store.getters.objectZoneGroupMode
    },
    markerLayersToEdit() {
      return this.$store.getters.markerLayersToEdit
    },
    zoneGroupToEdit() {
      return this.$store.getters.zoneGroupToEdit
    },
    showPriorityModal() {
      return this.$store.getters.showPriorityModal
    },
    showInfrastructureModal() {
      return this.$store.getters.infrastructureEdit
    },
    showTechnologyModal() {
      return this.$store.getters.infrastructureTechnologyEdit
    },
    objectSelected() {
      return this.$store.getters.objectSelected
    },
    objectsPeriod() {
      return this.$store.getters.objectsPeriod
    },
    priorityRuleToEdit() {
      return this.$store.getters.priorityRuleToEdit
    },
    objectShowContainerRoute() {
      return this.$store.getters.objectShowContainerRoute
    },
    objectStaticInfo() {
      return this.$store.getters.objectStaticInfo
    },
    objectDetailsSelected() {
      return this.$store.getters.objectDetailsSelected
    },

    /**
     * Специальный заголовок выбранного объекта
     * сейчас актуально для ОИ и территорий
     */
    selectedObjectName() {
      return this.$store.getters.selectedObjectName
    },

    routeHeight() {
      return this.objectShowContainerRoute ? (200 / this.container.height) * 100 : 0
    },
    additionalHeight() {
      return this.objectDetailsSelected && this.$store.getters.objectDetailsInfo && this.$store.getters.objectDetailsInfo.data
        ? (248 / this.container.height) * 100
        : (160 / this.container.height) * 100
    },
    mainPaneHeight() {
      return 100 - (this.panels.editRule ? this.currentSizes.rule : 0)
    },
    mapHeight() {
      let h = this.panels.additional ? 100 - this.additionalHeight : 100
      h = this.routeHeight ? h - this.routeHeight : h
      return h
    },
    token() {
      return this.$store.getters.token
    },
    isInitLoading() {
      return this.$store.getters.isInitLoading
    },
    newVersionExists() {
      return this.$store.getters.newVersionExists
    },

    isPriorityPanelActive() {
      if (!this.panels) {
        return false
      }
      return this.panels.priority
    },

    commonLayerLoadParamHash() {
      if (!this.mainLoaded) {
        return null
      }
      return this.$store.getters.commonLayerLoadParamHash
    },

    infoLayersLayerLoadParamHash() {
      if (!this.mainLoaded || !this.objectsPeriod || !this.objectsPeriod.borders) {
        return null
      }
      return this.$store.getters.infoLayersLayerLoadParamHash
    },

    infrastructureLayerLoadParamHash() {
      if (!this.mainLoaded) {
        return null
      }
      return this.$store.getters.infrastructureLayerLoadParamHash
    },

    flowLayerLoadParamHash() {
      if (!this.mainLoaded) {
        return null
      }
      return this.$store.getters.flowLayerLoadParamHash
    },

    sourceLayerLoadParamHash() {
      if (!this.mainLoaded) {
        return null
      }
      return this.$store.getters.sourceLayerLoadParamHash
    },

    zoneGroupLayerLoadParamHash() {
      if (!this.mainLoaded) {
        return null
      }
      return this.$store.getters.zoneGroupLayerLoadParamHash
    }
  },

  watch: {
    commonLayerLoadParamHash() {
      if (!this.commonLayerLoadParamHash) {
        return
      }

      this.$store.getters.defaultLayerLoadEntities.forEach((entity) => {
        this.$store.dispatch('layerLoadDefault', {
          entity
        })
      })
    },

    infoLayersLayerLoadParamHash() {
      if (!this.infoLayersLayerLoadParamHash) {
        return
      }
      this.$store.dispatch('layerLoadInfoLayers')
    },

    infrastructureLayerLoadParamHash() {
      if (!this.infrastructureLayerLoadParamHash) {
        return
      }
      this.$store.dispatch('layerLoadInfrastructure')
    },

    flowLayerLoadParamHash() {
      if (!this.flowLayerLoadParamHash) {
        return
      }
      this.$store.dispatch('layerLoadFlow')
    },

    sourceLayerLoadParamHash() {
      if (!this.sourceLayerLoadParamHash) {
        return
      }
      this.$store.dispatch('layerLoadSource')
    },

    zoneGroupLayerLoadParamHash: {
      handler() {
        if (!this.zoneGroupLayerLoadParamHash) {
          return
        }
        this.$store.dispatch('layerLoadZoneGroup')
      },
      immediate: true
    },

    isInitLoading(newVal) {
      if (!newVal) {
        this.initContainer()
        this.mapResized()
      }
    },

    isZoneMode(newVal) {
      if (newVal) {
        this.show3dMap = false
      }
    },

    objectsPeriod(newVal, oldVal) {
      if (newVal && this.objectSelected) {
        this.$store.dispatch('setObjectSelected', { ...this.objectSelected })
      }

      //Инициализация настроек слоев
      if (newVal) {
        if (oldVal && oldVal.borders) {
          return
        }

        this.$store
          .dispatch('loadWorkspaceSettings', {
            name: 'front_layer_layout',
            saveId: true
          })
          .then(() => {
            return this.$store.dispatch('setLayerSettingsAndStyles')
          })
          .then(() => {
            this.initLayers()
          })
      }
    },

    workspaceAndVersion(newVal, oldVal) {
      if (newVal.workspace && newVal.version) {
        this.initContainer()
        this.$store.dispatch('totalObjectsReset')
        this.closeZoneGroup()
        this.resetObjectSelected()
        clearTimeout(this.checkCacheTimeout)
        this.checkCache()
        this.$store.dispatch('getImmediateTimeVersion')
        this.openLayers()
        this.mapResized()
        this.initLayers()
        //Сброс быстрого поиска над списком слоев
        this.resetLayerTextFilter()
      }
      if (!newVal.workspace) {
        this.$store.dispatch('totalObjectsReset')
      }
      this.$store.dispatch('resetMarkerLayer')
    },

    objectDetailsSelected(newVal, oldVal) {
      if (newVal) {
        this.panels.additional = true
      }
    },

    objectSelected(newVal) {
      if (newVal) {
        this.panels.additional = true
        this.panels.main = true
      } else {
        this.resetObjectSelected()
      }
    },

    mapHeight() {
      this.mapResized()
    },

    priorityRuleToEdit(newVal) {
      this.panels.editRule = !!newVal
    },

    zoneGroupToEdit(newVal) {
      this.panels.zoneGroup = !!newVal
    },

    newVersionExists(newVal) {
      if (newVal && newVal.length > 0) {
        this.initLayers()
      }
    },

    show3dMap(newVal, oldVal) {
      this.toggle3dFlowMapHelperText()

      //Если было отключение 3d-карты
      if (oldVal && !newVal) {
        //Надо перерисовать источники и потоки
        //Другие слои перерисовываются, так как зависят от зума
        this.$nextTick(() => {
          if (this.$refs.objectsMap) {
            this.$refs.objectsMap.reloadFlowMapData()
            this.$refs.objectsMap.reloadSourceMapData()
          }
        })
      }
    },

    /**
     * Ослеживаем изменение видимости панели настройки потоков
     */
    isPriorityPanelActive(newValue) {
      if (!newValue) {
        //Восстановим видимость слоев тер. деления, которое было до включения панели настройки потоков
        this.restoreAdmLevelLayersVisibility()
      }
    }
  },

  created() {
    //Надо очистить быстрый поиск
    this.resetLayerTextFilter()
    this.panels = {
      ...this.defaultPanels,
      layers: true,
      additional: true
    }
  },

  mounted() {
    this.checkCache()
    if (this.workspaceAndVersion.workspace && this.workspaceAndVersion.version) {
      this.$store.dispatch('getImmediateTimeVersion')
      this.initContainer()
    }
    this.savedSizes = { ...this.currentSizes }
  },

  methods: {
    initContainer() {
      setTimeout(() => {
        this.container = {
          width: this.$refs.panes ? this.$refs.panes.container.clientWidth : 0,
          height: this.$refs.panes ? this.$refs.panes.container.clientHeight : 1
        }
      })
    },

    initLayers() {
      this.mainLoaded = false
      if (this.objectsPeriod && this.objectsPeriod.borders) {
        this.$store
          .dispatch('loadInfoLayerIcons') //Загрузка словаря иконок для инфослоев
          .catch(() => {
            this.$store.commit('setApiErrorInfo', 'Ошибка загрузки условных обозначений слоев')
          })
          .then(() => {
            return this.$store.dispatch('loadLayerColoring')
          })
          .catch(() => {
            this.$store.commit('setApiErrorInfo', 'Ошибка загрузки раскрасок слоев')
          })
          .finally(() => {
            this.mainLoaded = true
          })
      }
    },

    checkCache() {
      if (this.workspaceAndVersion.workspace && this.workspaceAndVersion.version) {
        this.$store.dispatch('getObjectsMapCache').then((r) => {
          this.checkCacheTimeout = setTimeout(() => {
            this.checkCache()
          }, 30000)
        })
      } else {
        clearTimeout(this.checkCacheTimeout)
      }
    },
    resetShowContainerRoute() {
      this.$store.commit('setShowContainerRoute', null)
    },
    openEditLayerPanel() {
      this.panels.editLayer = true
    },
    toggleFiltersPanel() {
      this.panels = {
        ...this.panels,
        filters: !this.panels.filters
      }
    },
    mapResized() {
      setTimeout(() => {
        this.newMapContainerSize = {}
      }, 250)
    },
    openLayerSettingsPopup() {
      this.$ui.popup.show({
        component: () => import('@/components/objects/LayerSettingsEditor'),
        params: {
          width: '700px'
        }
      })
    },
    openLayerLinkColorPopup() {
      this.$ui.popup.show({
        component: ColorSettings,
        params: {
          width: '610px'
        }
      })
    },

    /**
     * Свернуть все слои (сворачиваются и группы и слои у которых раскрыт список объектов)
     */
    collapseAllLayers() {
      this.$store.dispatch('collapseAllLayers')
    },

    forceDefaultVisibilityPanels() {
      this.$store.dispatch('resetDefaultLayerVisibility')
    },
    hideAllLayers() {
      //Скрыть маршрут выбранного объекта линейного инфослоя
      this.$store.commit('setShowRouteForSelectedStreaminfoObject', false)

      //Скрыть все слои
      this.$store.dispatch('hideAllLayers')
    },
    resetObjectSelected() {
      this.panels.main = false
      this.$store.dispatch('setObjectSelected', null)
    },
    resetObjectDetailsSelected() {
      this.$store.commit('setObjectDetailsInfo', null)
      this.$store.commit('setObjectDetailsSelected', null)
    },
    toggleAdditional() {
      this.panels = {
        ...this.panels,
        additional: !this.panels.additional
      }
      if (!this.panels.additional) {
        this.resetObjectDetailsSelected()
      }
    },
    hidePeriodPanel() {
      this.periodPanelSettings = null
    },
    changeIntervals($event) {
      this.selectedIntervals = $event
      this.hidePeriodPanel()
    },
    openLayers() {
      this.resetZoneGroupsMode()

      this.panels = {
        ...this.defaultPanels,
        layers: true,
        additional: true
      }
    },
    closeLayers() {
      this.panels = {
        ...this.defaultPanels,
        layers: false,
        filters: false
      }
    },
    closePriorities() {
      this.panels = {
        ...this.defaultPanels,
        layers: true,
        additional: true
      }
    },
    openPriorities() {
      this.resetObjectSelected()
      this.resetObjectDetailsSelected()
      this.resetZoneGroupsMode()
      this.panels = {
        ...this.defaultPanels,
        priority: true
      }
    },
    toggleZoneGroup() {
      if (!this.panels.zoneGroups) {
        this.$store.commit('setZoneGroupPeriod', {
          ...this.objectsPeriod,
          borders: [this.objectsPeriod.borders[0], this.objectsPeriod.borders[0]]
        })
        this.$store.commit('setObjectZoneGroupMode', true)
      } else {
        this.resetZoneGroupsMode()
      }
      this.panels = {
        ...this.defaultPanels,
        layers: this.panels.zoneGroup,
        additional: this.panels.zoneGroup,
        zoneGroups: !this.panels.zoneGroups,
        zoneGroup: this.panels.zoneGroups ? false : this.panels.zoneGroup
      }
    },
    resetZoneGroupsMode() {
      this.$store.commit('setObjectZoneGroupMode', false)
      this.$store.commit('setZoneGroupPeriod', null)
    },
    toggleTerritories() {
      this.panels = {
        ...this.defaultPanels,
        layers: this.panels.territories,
        additional: this.panels.territories,
        territories: !this.panels.territories,
        territory: this.panels.territories ? false : this.panels.territory
      }
    },
    closeZoneGroup() {
      // add reset selection
      this.panels = {
        ...this.panels,
        zoneGroup: false
      }
      this.$store.commit('setZoneGroupToEdit', null)
    },
    closeFilters() {
      // add reset selection
      this.panels = {
        ...this.panels,
        filters: false
      }
    },
    closeTerritory() {
      // add reset selection
      this.panels = {
        ...this.panels,
        territory: false
      }
    },
    resetRuleToEdit() {
      this.$store.commit('setPriorityRuleToEdit', null)
    },

    handleTerritoryLoadingStart() {
      this.territoryLoading = true
      this.territoryLoadingError = false
    },

    toggle3dFlowMapHelperText() {
      this.helperText = this.show3dMap ? 'Отключить трехмерную карту потоков' : 'Включить трехмерную карту потоков'
    },

    /**
     * Нажитие кнопки "Настройка потоков"
     */
    priorityConfigClick() {
      //по задаче https://app.clickup.com/t/2vj62c9
      //Надо при включении режима "Настройка потоков" показать тер деление по выделенным территориям
      //При выключения вернуть тер деление как было

      if (this.panels.priority) {
        this.closePriorities()
      } else {
        //Получим настройки текущего видимого уровня административного деления
        this.prevVisibleAdmLevelLayerSettings = this.$store.getters.getFirstVisibleAdmLevelLayerSettings
        //Получение дочерних видимых слоев уровня адм. деления
        //Таким образом мы сохраним их видимость, чтобы восстановить при выключении режима настройки потоков
        if (this.prevVisibleAdmLevelLayerSettings) {
          this.admLevelChildVisibleLayerSettings = this.$store.getters.getVisibleChildLayerSettings(this.prevVisibleAdmLevelLayerSettings.id)
        } else {
          this.admLevelChildVisibleLayerSettings = null
        }

        //Возьмем уровень административного деления "Выделенные территории"
        const dedicatedTerritoryAdmLevel = this.$store.getters.getFirstDedicatedTerritoryLayerSettings

        if (dedicatedTerritoryAdmLevel) {
          //Выключим отображение группы зон
          this.$store
            .dispatch('setLayerVisibility', {
              layerId: dedicatedTerritoryAdmLevel.parentId,
              visibility: false,
              checkSingleChildVisibility: true,
              toggleSiblingVisibility: true
            })
            .then(() => {
              //Включим отображение уровня административного деления "Выделенные территории"
              this.$store.dispatch('setLayerVisibility', {
                layerId: dedicatedTerritoryAdmLevel.id,
                visibility: true,
                checkSingleChildVisibility: true,
                toggleSiblingVisibility: true
              })
            })
        }

        this.openPriorities()
      }
    },

    /**
     * Востановление видимости слоев тер. деления, которое было до того как включили панель настройки потоков
     */
    restoreAdmLevelLayersVisibility() {
      if (!this.prevVisibleAdmLevelLayerSettings) {
        //Скроем тер деление, если все было скрыто
        this.$store.dispatch('setLayerVisibility', {
          layerId: 'zonegroup',
          visibility: false,
          checkSingleChildVisibility: true,
          toggleSiblingVisibility: true
        })
        return
      }

      //Восстановление видимости территориального деления, которое было до перехода в режим настройки потоков
      //Сначала скроем Группу зон, уровня, активного до того как включили настройку потоков
      this.$store
        .dispatch('setLayerVisibility', {
          layerId: this.prevVisibleAdmLevelLayerSettings.parentId,
          visibility: false,
          checkSingleChildVisibility: true,
          toggleSiblingVisibility: true
        })
        .then(() => {
          //Потом включим видимость дочерних слоев уровня адм. деления, который был активен до перехода в режим настройки потоков
          this.admLevelChildVisibleLayerSettings.forEach((layerSettings) => {
            this.$store.dispatch('setLayerVisibility', {
              layerId: layerSettings.id,
              visibility: true,
              checkSingleChildVisibility: true,
              toggleSiblingVisibility: true
            })
          })
        })
    },

    /**
     * Вызывается при изменении строки "Быстрый поиск" над списком слоев
     * вызывает перезагрузку слоев с параметром text
     */
    handleObjectFiltersChanged() {
      this.$store.dispatch('layerLoadInfrastructure')
      this.$store.dispatch('layerLoadSource')
      this.$store.dispatch('layerLoadFlow')
      this.$store.dispatch('layerLoadInfoLayers')
      this.$store.dispatch('layerLoadDefaultLayers')
    },

    resetLayerTextFilter() {
      this.$store.commit('setObjectFiltersText', {
        text: ''
      })
      this.$store.commit('setLayerFilterText', {
        layerFilterText: ''
      })
      this.$store.commit('setOpenedBySearchLayerIds', {
        openedBySearchLayerIds: []
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '~base';
.ObjectsMenu {
  display: flex;
  align-items: center;

  &-nav {
    display: flex;
    align-items: center;
    margin-left: 15px;
  }

  &-treatments-select {
    flex: 0 0 auto;
  }
}

.Objects {
  &-spinner {
    position: absolute;
    top: 45%;
    left: 50%;
    width: 32px;
    height: 32px;
    margin: -16px 0 0 -16px;
    border-radius: 5px;
    z-index: 1000;

    .Spinner {
      margin: 10px 0 0 13px;
    }
  }

  &-switcher {
    position: relative;
    margin-left: 12px;
    padding-left: 20px;
    font-size: 14px;

    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      left: 0;
      width: 1px;
      background: var(--delimiter);
      top: 7px;
      bottom: 6px;
    }
  }
}

.IconColorSettings {
  font-size: 16px;
}

.IconLayerSettings {
  font-size: 16px;
}

.ObjectsModal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 11000;
  background: var(--appBg);
}

/**Костыль с выравниванием размера иконок */
.IconVisible {
  font-size: 12px;
}
.IconHidden {
  font-size: 14px;
}
@media screen and (max-width: 860px) {
  .Objects-switcher {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Objects.vue